export default __webpack_public_path__ + "static/media/ChevronRight.6cca9fd3.svg";